// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { ReturnRequestDetail } from './return-request-detail';
import { ReturnRequestDetailStatusEnum } from './enums';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class ReturnRequestDetailStatus extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Enum key */
  id!: ReturnRequestDetailStatusEnum;
  /** Boolean */
  isFinalState!: boolean;
  /** String(50) */
  name!: string;
  /** Inv FK returnRequestDetailStatusId */
  returnRequestDetails!: ReturnRequestDetail[];
}

